<template>
  <div class="room air-station">
    <refresh-block @refreshData="refreshData"></refresh-block>
    <div class="air-left">
      <div class="air-diagram" v-loading="loading">
        <history-data v-if="!loading" :statusClass="diagramStatus" title="湿度实时曲线 (%) RH"
                      :legendData="diagramLegendData"
                      :series="diagramSeries">
        </history-data>
      </div>
      <div class="air-switch">
        <switch-status title="除湿机1" :series="switch1Status1"></switch-status>
      </div>
      <div class="air-switch">
        <switch-status title="循环风机1" :series="switch2Status1"></switch-status>
      </div>
      <div class="air-switch">
        <switch-status title="除湿机2" :series="switch1Status2"></switch-status>
      </div>
      <div class="air-switch">
        <switch-status title="循环风机2" :series="switch2Status2"></switch-status>
      </div>
    </div>
    <div class="air-right">
      <div class="temp-warp" v-loading="loading">
        <div class="temp-title">锚室温湿度</div>
        <div class="temp-tt">
          <single-pie-histogram-wrap v-if="!loading" :opts="SinglePieHistogramWrapOpts1" :class="warningFlag1"
                                     :series="SinglePieHistogramWrapData1"></single-pie-histogram-wrap>
        </div>
        <div class="temp-tt">
          <single-pie-histogram-wrap v-if="!loading" :opts="SinglePieHistogramWrapOpts2" :class="warningFlag2"
                                     :series="SinglePieHistogramWrapData2"></single-pie-histogram-wrap>
        </div>
      </div>
      <div class="ari-running-time" v-loading="loading">
        <running-time-big v-if="!loading" title="运行时间" :series="runningTime"></running-time-big>
      </div>
    </div>
  </div>
</template>
<script>
  import airStationJson from './airStation.json'

  export default {
    name: 'airStation',
    data() {
      return {
        loading: false,
        warningFlag1: '',
        warningFlag2: '',
        SinglePieHistogramWrapData1: {},
        SinglePieHistogramWrapData2: {},
        SinglePieHistogramWrapOpts1: {
          title: 'T1',
          histogramName1: 'T',
          center1: ['50%', '60%'],
          radius1: ['46%', '70%'],
          pieName1: 'RH',
          max: 50,
          pieMax: 100,
          toprichFontSize: 18,
          topFontSize: 20,
          sign: '°C'
        },
        SinglePieHistogramWrapOpts2: {
          title: 'T2',
          histogramName1: 'T',
          center1: ['50%', '60%'],
          radius1: ['46%', '70%'],
          pieName1: 'RH',
          max: 50,
          pieMax: 100,
          toprichFontSize: 18,
          topFontSize: 20,
          sign: '°C'
        },
        diagramLegendData: ['湿度1', '湿度2'],
        diagramSeries: [],
        diagramStatus: '',
        runningTime: '',
        switch1Status1: {},
        switch1Status2: {},
        switch2Status1: {},
        switch2Status2: {},
        timeFunc: null,
        stationIdList: {
          airStationOne: '56a96626-a9f2-46cb-bf3c-02a01cbea4b1', // 1#制备站
          airStationTwo: '0e298c23-9326-437c-b2d2-067f634cdd27', // 2#制备站
          airStationThree: '72f35082-9439-4ec3-8cf3-79e04c5c663c', // 3#制备站
          airStationFour: '55afc2be-8d18-4852-b8f8-3e39229ebef5', // 4#制备站
        }
      }
    },
    watch: {
      /**
       * 监听路由变化
       * @param {Object} route # 当前路由信息
       */
      '$route'(route) {
        this.initData(route)
      }
    },
    created() {
      this.initData(this.$route)
      this.timeFunc = setInterval(() => {
        this.initData(this.$route)
      }, this.REFRESH_SECOND)
    },
    destroyed() {
      clearInterval(this.timeFunc)
      this.timeFunc = null
    },
    methods: {
      /**
       * 加载数据
       * @param {Object} route # 当前路由信息
       */
      initData({ name }) {
        this.loading = true
        const deviceList = airStationJson[name]
        const oneHttp = this.$http.get(`/deviceData/Station?stationId=${this.stationIdList[name]}`)
        const twoHttp = this.$http.get(`/statistics/DeviceData?deviceId=${deviceList[7].deviceId}&interval=BY_HOUR&insertBlankData=true`)
        const threeHttp = this.$http.get(`/statistics/DeviceData?deviceId=${deviceList[8].deviceId}&interval=BY_HOUR&insertBlankData=true`)

        this.$http.all([oneHttp, twoHttp, threeHttp]).then(this.$http.spread(({ data = {} }, res2, res3) => {
          this.$store.commit('setLastRefreshTime')
          this.loading = false
            this.switch1Status1 = {
              data: data[deviceList[0].deviceId].value,
              isError: data[deviceList[0].deviceId].errorLevel,
            }
            this.switch1Status2 = {
              data: data[deviceList[1].deviceId].value,
              isError: data[deviceList[1].deviceId].errorLevel,
            }
            this.switch2Status1 = {
              data: data[deviceList[2].deviceId].value,
              isZh: true,
              isError: data[deviceList[2].deviceId].errorLevel,
            }
            this.switch2Status2 = {
              data: data[deviceList[3].deviceId].value,
              isZh: true,
              isError: data[deviceList[3].deviceId].errorLevel,
            }
            this.runningTime = data[deviceList[4].deviceId].value
            this.$nextTick(() => {
              this.SinglePieHistogramWrapData1 = {
                data1: data[deviceList[5].deviceId].value,
                data2: data[deviceList[7].deviceId].value
              }
              this.warningFlag1 = data[deviceList[5].deviceId].errorLevel
              if (data[deviceList[7].deviceId].errorLevel === 'Error') this.warningFlag1 = 'Error'
              this.SinglePieHistogramWrapData2 = {
                data1: data[deviceList[6].deviceId].value,
                data2: data[deviceList[8].deviceId].value
              }
              this.warningFlag2 = data[deviceList[6].deviceId].errorLevel
              this.diagramStatus = data[deviceList[7].deviceId].errorLevel
              if (data[deviceList[8].deviceId].errorLevel === 'Error') {
                this.warningFlag2 = 'Error'
                this.diagramStatus = 'Error'
              }
              const aryOne = {}
              const aryTwo = {}
              res2.data.dataList.forEach(val => {
                aryOne[val.StatisticsDate] = val.value
              })
              res3.data.dataList.forEach(val => {
                aryTwo[val.StatisticsDate] = val.value
              })
              this.diagramSeries = [aryOne, aryTwo]
            })
          })
        )
      },
      refreshData() {
        this.initData(this.$route)
        clearInterval(this.timeFunc)
        this.timeFunc = setInterval(() => {
          this.initData(this.$route)
        }, this.REFRESH_SECOND)
      },
      getData() {
        if (!this.loading) this.initData(this.$route)
      }
    }
  }
</script>
<style lang="scss">
  .air-station {
    .graph-wrapper {
      padding-left: 0;
      padding-right: 0;
    }
  }
</style>
<style lang="scss" scoped>
  .temp-warp {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.6);
    padding: 20px 0 50px;
    box-sizing: border-box;
    position: relative;

    .temp-title {
      position: absolute;
      top: 10px;
      left: 10px;
    }
  }

  .temp-tt {
    height: 60%;
    width: 40%;
  }

  .air-station {
    display: flex;
    flex-direction: row;
    padding: 10px 0 30px;
    box-sizing: border-box;
    justify-content: space-between;
  }

  .air-left {
    width: calc(65% - 20px);
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: space-between;
    justify-content: space-between;
  }

  .air-diagram {
    width: 100%;
    height: calc(100% - 142px);
    background-color: rgba(255, 255, 255, 0.6);
  }

  .air-switch {
    width: calc(50% - 10px);
    height: 42px;
  }

  .ari-running-time {
    width: 100%;
    height: 112px;
  }

  .temp-warp {
    width: 100%;
    height: calc(100% - 142px);
  }

  .air-right {
    width: 35%;
    height: 100%;
    display: flex;
    flex-direction: column;;
    justify-content: space-between;
  }
</style>
